// extracted by mini-css-extract-plugin
export var button = "_lv-2";
export var card = "_lv-0";
export var closeButtonContainer = "_lv-3";
export var iconContainer = "_lv-1";